export const IsDisableCell = ({ disableCellRef, columnName, rowName }) => {
    if(!!rowName===false) return false;
    const rowTitle = rowName?.split(' ')?.join('_')
    const columnTitle = columnName.split(' ').join('_')
    return rowTitle+'_'+columnTitle in disableCellRef;
}